var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2699_2567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05225 9.89354C7.68603 9.89354 9.66553 9.89354 9.66553 9.89354C10.1904 9.89354 10.6157 9.46826 10.6157 8.94335C10.6157 8.41845 10.1904 7.99316 9.66553 7.99316C9.19044 7.99316 8.24025 7.99316 5.86475 7.99316C3.48878 7.99316 2.73681 8.98291 1.90528 9.81445L0.3965 11.1323C0.298844 11.2173 0.242188 11.3408 0.242188 11.4702V15.8501C0.242188 15.9087 0.276375 15.9619 0.329594 15.9864C0.382812 16.0103 0.445312 16.002 0.48975 15.9639L3.40578 13.4639C3.50881 13.3765 3.64553 13.3394 3.77834 13.3633L8.32228 14.1895C8.63919 14.2471 8.96584 14.1744 9.22903 13.9883C9.22903 13.9883 15.0293 9.95557 15.4571 9.5991C15.8653 9.2246 15.8604 8.68113 15.4859 8.27291C15.1109 7.86373 14.4117 7.95063 13.9453 8.29585C13.5181 8.65229 10.5992 10.5708 10.5992 10.5708H7.05228L7.04106 10.5756C6.85406 10.5698 6.70806 10.413 6.71391 10.2265C6.72075 10.0395 6.877 9.89301 7.06353 9.89935L7.05225 9.89354Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3413 0C10.4771 0 9.72216 0.461906 9.30469 1.15138C10.6397 1.64113 11.5967 2.92141 11.5967 4.42384C11.5967 4.53469 11.5903 4.64406 11.5801 4.75247C12.7837 4.63234 13.7237 3.61722 13.7237 2.38188C13.7237 1.06641 12.6572 0 11.3413 0Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.188 3.78809H7.8125V4.54443H8.188C8.42578 4.54443 8.61916 4.37449 8.61916 4.16602C8.61913 3.95802 8.42578 3.78809 8.188 3.78809Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10547 1.70117C6.60206 1.70117 5.38281 2.92042 5.38281 4.42383C5.38281 5.92773 6.60206 7.14648 8.10547 7.14648C9.60887 7.14648 10.8281 5.92773 10.8281 4.42383C10.8281 2.92042 9.60891 1.70117 8.10547 1.70117ZM8.19094 4.96436H7.81544V5.51464C7.81544 5.62061 7.7295 5.70605 7.62403 5.70605H7.52784C7.42187 5.70605 7.33644 5.62061 7.33644 5.51464V3.55958C7.33644 3.45411 7.42187 3.36817 7.52784 3.36817H8.19094C8.69338 3.36817 9.10159 3.72608 9.10159 4.16602C9.10156 4.60645 8.69338 4.96436 8.19094 4.96436Z",
    fill: "#344767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2699_2567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/pointsIcon.a980473bb51683ee2d7955634fa22398.svg";
export { ForwardRef as ReactComponent };